function data() {
	return {
		modalConfirmation: {
			selectedRow: {},
			value: false,
		},
		languages: {
			es: {
				id: 'Es',
				name: 'Español',
				isSelected: false,
			},
			en: {
				id: 'En',
				name: 'English',
				isSelected: false,
			},
		},
		params: {
			page: 1,
			perPage: 30,
			search: null,
		},
		table: {
			lastPage: 0,
			rows: [],
		},
	};
}

function cancelModalConfirmation() {
	this.modalConfirmation.value = false;
}

function goTo(name, options) {
	this.$router.push({ name, ...options });
}

function getImageUrl(imageUrl) {
	return `${this.$imageUrl}/${imageUrl}`;
}

async function loadData(url, version = 2) {
	const query = {
		params: this.params,
	};
	if (version === 2) {
		query.headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
	}
	const { data: records, headers } = await this.$http.get(url, query);
	this.table.lastPage = Number(headers['x-last-page']);
	this.table.rows = records.data.map((row) => {
		const newRow = { ...row };
		newRow.isSelected = !!row.isSelected || !!row.flagSelected;
		return newRow;
	});
	return { records, headers };
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.loadData(url);
}

function openModalConfirmation(row) {
	this.modalConfirmation.selectedRow = row;
	this.modalConfirmation.value = true;
}

function showError(text = 'Oops, ocurrió un error.') {
	this.$store.dispatch('showSnackBar', { text, color: 'error' });
}

function showNotification(text, color = 'success') {
	this.$store.dispatch('showSnackBar', { text, color });
}

function showParentView(name) {
	return this.$route.name.indexOf(name) > -1;
}

function showRow(columns, columnId) {
	const column = columns.find(h => h.id === columnId);
	return column.visible;
}

function selectIsRow(array, flag = 'isSelected', row, checked, config) {
	const arrayNew = array.map((rowData) => {
		const newRowData = { ...rowData };
		if (config) {
			if (newRowData[config]) {
				newRowData[flag] = checked;
			} else {
				newRowData[flag] = false;
			}
		} else if (row) {
			if (rowData.id === row.id) {
				newRowData[flag] = row[flag];
			}
		} else {
			newRowData[flag] = checked;
		}
		return newRowData;
	});
	return arrayNew;
}

function every(array, flag = 'isSelected', disabled) {
	const newArray = Object.assign([], array);
	let returnEvery;
	if (disabled) {
		returnEvery = newArray.every(element => !element[flag]);
	} else {
		returnEvery = newArray.every(element => element[flag]);
	}
	return returnEvery;
}

function token() {
	return this.$store.getters.token;
}

const mixin = {
	data,
	computed: {
		token,
	},
	methods: {
		cancelModalConfirmation,
		getImageUrl,
		goTo,
		loadData,
		onSearch,
		openModalConfirmation,
		showError,
		showNotification,
		showParentView,
		showRow,
		selectIsRow,
		every,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js